import { GraphQLResult, GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { Modal } from "antd";
import { API } from "aws-amplify";
import React from "react";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import {
  AccountMovement,
  GenerateGameSessionTokenAtlasMutation,
  GetMovementQuery,
} from "../../API";
import { useAppSelector } from "../../app/hooks";
import { selectPlayer } from "../../features/player/playerSlice";
import {
  Localization,
  selectTheme,
  showLoading,
  ThemeColor,
  ThemeMode,
} from "../../features/theme/themeSlice";
import { generateGameSessionTokenAtlas } from "../../graphql/mutations";
import { getMovement } from "../../graphql/queries";
import useAccount from "../../hooks/useAccount";
import AppLocale from "../../lang";
import PrintPlacebet from "../account/components/PrintPlacebet";

const SportLive: React.FC = () => {
  const dispatch = useDispatch();
  const theme = useAppSelector(selectTheme);
  const { accountRefresh } = useAccount();
  const [printTicket, setPrintTicket] = useState<number>(0);
  const [modalTicket, setModalTicket] = useState<boolean>(false);
  const intl = useIntl();
  const player = useAppSelector(selectPlayer);
  const [ticketMovement, setTicketMovement] = useState<AccountMovement | null>(
    null
  );
  /* localization */
  const locale: Localization = theme.language as any;
  const languages: any = { it: "ITA", en: "ENG" };
  const language = languages[locale];
  const currentAppLocale = AppLocale[locale];

  const iframeDeskRef: any = React.createRef();

  const [sessionToken, setSessionToken] = useState<any | null>(null);

  const generateGameSession = () => {
    let lastPrintedId: number | null = 0;
    dispatch(showLoading(true));
    console.log("PLAYER LOGGED:", player.logged);
    (async () => {
      const result: GraphQLResult<GenerateGameSessionTokenAtlasMutation> =
        (await API.graphql({
          query: generateGameSessionTokenAtlas,
          authMode: player.logged
            ? GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
            : GRAPHQL_AUTH_MODE.AWS_IAM,
          variables: {
            staging: true,
            lang: language,
            category: "sport",
            currency: player.logged ? player.account?.valute : "EUR",
          },
        })) as GraphQLResult<GenerateGameSessionTokenAtlasMutation>;
      console.log(result.data);
      if (!result.errors) {
        setSessionToken(result.data?.generateGameSessionTokenAtlas);
        window.addEventListener("message", (event) => {
          if (event.data.action === "ui:goto") {
            /* console.info("UI:GOTO", event.data.payload); */
          }
        //  console.log("IFRAME EVENT", event);
          if (
            theme.mode === ThemeMode.KIOSK &&
            event.data.action === "bet:placedSuccess"
          ) {
            if (lastPrintedId != event.data.payload.data.bets[0].betId) {
              lastPrintedId = event.data.payload.data.bets[0].betId;
              setPrintTicket(lastPrintedId);
              console.log(
                "print bet id: ",
                event.data.payload.data.bets[0].betId
              );
            }
          }
        });
      }
    })();
  };

  useEffect(() => {
    window.scrollTo({top: 0, left: 0});
    if (iframeDeskRef.current) {
      if (theme.theme == ThemeColor.light) {
        iframeDeskRef.current.contentWindow.postMessage(
          {
            action: "ui:theme_change",
            payload: "light",
          },
          "*"
        );
      } else {
        iframeDeskRef.current.contentWindow.postMessage(
          {
            action: "ui:theme_change",
            payload: "dark",
          },
          "*"
        );
      }
    }
  }, [theme.theme]);
  /*************** */

  useEffect(() => {
    if (printTicket !== 0 && theme.mode === ThemeMode.KIOSK) {
      (async () => {
        try {
          const result: GraphQLResult<GetMovementQuery> = (await API.graphql({
            query: getMovement,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: {
              PK: `ATLAS#BETID#${printTicket}`,
            },
          })) as GraphQLResult<GetMovementQuery>;
          setTicketMovement(result.data.getMovement);
          setModalTicket(true);
          console.log(result);
        } catch (e) {
          alert("errore \n" + JSON.stringify(e));
          setPrintTicket(0);
        }
      })();
    }
  }, [printTicket]);

  useEffect(() => {
    if (sessionToken) {
      console.log(sessionToken);
    }
  }, [sessionToken]);

  useEffect(() => {
    if (player.logged && player.account && !sessionToken) {
      generateGameSession();
    }
  }, [player.logged, player.account]);

  useEffect(() => {
    if (!player.logged) generateGameSession();

    return () => {
      dispatch(showLoading(false));
    };
  }, []);
  return (
    <div className="d-sport">
      {(theme.isMobile || theme.isTablet) && sessionToken && (
        <iframe
          ref={iframeDeskRef}
          loading="eager"
          onLoad={() => {
            dispatch(showLoading(false));
          }}
          src={`https://m-c115x.play-platform.com/live?token=${
            sessionToken?.sessionToken
          }&lang=${language}&theme=${
            theme.theme == ThemeColor.dark ? "dark" : "light"
          }`}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            border: "none",
            outline: "none",
            margin: 0,
          }}
        />
      )}
      {!theme.isMobile && !theme.isTablet && sessionToken && (
        <iframe
          ref={iframeDeskRef}
          loading="eager"
          onLoad={() => {
            dispatch(showLoading(false));
          }}
          src={`https://c115x.play-platform.com/live?token=${
            sessionToken?.sessionToken
          }&lang=${language}&theme=${
            theme.theme == ThemeColor.dark ? "dark" : "light"
          }`}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            border: "none",
            outline: "none",
            margin: 0,
          }}
        />
      )}
      <Modal
        visible={modalTicket}
        title={intl.formatMessage({ id: "print.ticket" })}
        okText="Print "
        onCancel={() => {
          setModalTicket(false);
          setPrintTicket(0);
        }}
        onOk={() => {
          (() => {
            const divContents =
              document.getElementById("ticket-print").innerHTML;
            // const a = window.open('', '', 'width=800');
            // a.document.write('<html>');
            // a.document.write(`<head>
            // 	<style>
            // 		img{width:100%;margin-bottom:20px}
            // 		@page {
            // 			margin: 1cm;
            // 			size: letter;
            // 		  }

            // 	table{ border-spacing: 0; width: 100%}
            // 	table th { border: 1px solid black;background:black; color:white }
            // 	table td { border: 1px solid black; }
            // 	</style>
            // </head>`);
            // a.document.write('<body>');
            // a.document.write('<img src="images/logo.png" />');
            // a.document.write(divContents);
            // a.document.write('</body></html>');
            // a.print();
            // setTimeout(() => {}, 700);

            function closePrint(this: any) {
              document.body.removeChild(this.__container__);
            }

            function setPrint(this: any) {
              this.contentWindow.__container__ = this;

              this.contentWindow.document.write(
                `<style>
								@media print {
									body { -webkit-print-color-adjust: exact; }
									@page { width:80mm; margin-top: 0; margin-bottom: 0; }
								}
								body {font-size: 1.5em;} table td{border: 1px solid black;padding:4px} table{border-spacing: 0;} img{width:100%; margin-bottom:10px}</style>
								<img src="/images/logo-printer.png" /><br>
								${divContents}`
              );
              this.contentWindow.onbeforeunload = closePrint;
              this.contentWindow.onafterprint = closePrint;
              this.contentWindow.focus(); // Required for IE
              setTimeout(() => {
                this.contentWindow.print();
              }, 700);
            }

            const oHiddFrame = document.createElement("iframe");
            oHiddFrame.onload = setPrint;
            oHiddFrame.style.position = "fixed";
            oHiddFrame.style.right = "0";
            oHiddFrame.style.bottom = "0";
            oHiddFrame.style.width = "0";
            oHiddFrame.style.height = "0";
            oHiddFrame.style.border = "0";

            document.body.appendChild(oHiddFrame);
          })();

          setModalTicket(false);
        }}
      >
        <p id="ticket-print">
          {ticketMovement && <PrintPlacebet movement={ticketMovement} />}
        </p>
      </Modal>
    </div>
  );
};

export default SportLive;
